import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { brandColors, hoverOnly } from '../../theme/mixins';

// The footer sits in the layout's flex flow (Layout is a min-height:100vh
// column), so it rests at the bottom on short pages and scrolls away on long
// ones. It used to be position:fixed, which is why the content area was capped
// at calc(100vh - 136px).
export const getFooterStyles = (theme: Theme): SxProps<Theme> => ({
    top: 'auto',
    borderRadius: 0,
    backgroundColor: 'rgba(255,255,255,0.8)',
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
    borderTop: '1px solid rgba(16,24,40,0.07)',
    boxShadow: 'none',
});

export const footerToolbarStyles: SxProps<Theme> = {
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    minHeight: '56px !important',
};

export const footerTextStyles: SxProps<Theme> = {
    color: 'text.secondary',
};

// The clinic's contact icons, at the other end of the toolbar's space-between.
export const socialBoxStyles: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
};

// Deliberately *not* in each network's own brand colour, which is what the hardcoded
// version did (#E4405F for Instagram, #1877F2 for Facebook, and so on). Those hexes belong
// to Meta and Google; the footer belongs to the clinic. Resting grey and hovering to the
// tenant's primary keeps four icons reading as one set in whatever palette the clinic
// chose, and keeps a raw brand hex out of a styles file -- see the rule in CLAUDE.md.
//
// Through hoverOnly, never an unguarded hover key: a touch browser leaves the hover state
// on the last-tapped element, so a raw colour change would strand one icon looking selected.
export const socialIconStyles: SxProps<Theme> = {
    color: 'text.secondary',
    transition: 'color 0.2s ease',
    ...hoverOnly({ color: brandColors.primary }),
};
